var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 137,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 0,
    width: 37,
    height: 37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.06,27.62c0-2.86,0-5.72,0-8.58,0-.42-.1-.59-.55-.57-.82.04-1.64,0-2.46.02-.3,0-.41-.08-.41-.4.01-2.15.01-4.3,0-6.45,0-.37.14-.46.48-.45.74.02,1.49,0,2.23,0,.69,0,.68,0,.69-.71.01-1.25-.06-2.5.06-3.74.2-2.26,1.02-4.23,3.02-5.53.98-.63,2.07-.95,3.22-.98,1.85-.03,3.7,0,5.55-.02.28,0,.39.08.39.38-.01,1.82-.01,3.64,0,5.45,0,.32-.11.4-.41.4-1.09-.02-2.18,0-3.27,0-.91,0-1.47.46-1.54,1.38-.07,1.01-.04,2.02-.06,3.03,0,.36.24.35.48.35,1.44,0,2.88,0,4.31,0,.61,0,.59.01.53.62-.16,1.63-.29,3.27-.43,4.9-.04.49-.08.98-.1,1.46,0,.31-.2.3-.42.3-1.38,0-2.75.01-4.12,0-.4,0-.5.11-.5.5.01,5.75,0,11.51.02,17.26,0,.45-.1.59-.57.58-1.85-.03-3.7-.03-5.55,0-.5,0-.59-.16-.59-.62.02-2.86,0-5.72,0-8.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a4aa6e75cb13760232e7e77ee4b8ec7f.svg";
export { ForwardRef as ReactComponent };